import React from "react";
import "../Table/Table.css";
import DataTable from "../DataTable/DataTable";
import ViewButton from "./ViewButton";

function MSADocument() {
  // MSA static data
  const msaData = [
    {
      id: 1,
      name: "Egon - MSA - 24.02.2025",
      link: "https://diridob2c.s3.ap-south-1.amazonaws.com/Egon%20-%20MSA%20-%2024.02.2025.pdf",
    },
    {
      id: 2,
      name: "Egon_MSA_VTSOW_26_05_2025_Signed",
      link: "https://diridob2c.s3.ap-south-1.amazonaws.com/Egon_MSA_VTSOW_26_05_2025_Signed.pdf",
    },
  ];

  const columns = [
    { field: "name", headerName: "Name", width: 600 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", gap: "5px", alignItems: "center", marginTop: "8px" }}>
            <ViewButton filePath={params.row.link} buttonText="VIEW MSA" />
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div
        className="table-header"
        style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}
      >
        <h2>Master Service Agreement (MSA)</h2>
      </div>

      {/* TABLE */}
      <div style={{ marginBottom: "30px" }}>
        <DataTable columns={columns} rows={msaData} />
      </div>
    </div>
  );
}

export default MSADocument;